/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useRef, useEffect } from 'react';
import DataTable from 'react-data-table-component';
import Cookies from 'js-cookie';
import ReactLoading from 'react-loading';
import { toast } from 'react-toastify';
import InfiniteScroll from 'react-infinite-scroller';
import api from 'api';
import { Header, SideMenu, Search, Input, Dialog, Button, Select } from 'components';
import {
  Container,
  ContentArea,
  Title,
  Div,
  DataArea,
  LoadingArea,
  SelectLine,
  CountArea,
  Subtitle,
  ModalButton,
} from './styles';
import { loadingColor, primary } from 'styles/colorProvider';
import { dataColumns } from './helper';

function User({ history }) {
  const scrollParent = useRef();

  const [loading, setLoading] = useState(false);
  const [userList, setUserList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [loadingMore, setLoadingMore] = useState(false);
  const [totalCount, setTotalCount] = useState();
  const [hasNextPage, setHasNextPage] = useState();
  const [search, setSearch] = useState();
  const [open, setOpen] = useState(false);
  const [loadingData, setLoadingData] = useState(false);
  const [featureAcess, setFeatureAcess] = useState([]);
  const [inviteData, setInviteData] = useState();
  const [selectedAccesGroup, setSelectedAccessGroup] = useState();

  const inviteUser = async (e) => {
    setLoadingData(true);
    try {
      const response = await api({
        method: 'POST',
        url: '/invite',
        headers: {
          'Content-Type': 'application/json',
          Authorization: Cookies.get('splitrisk-authtoken'),
        },
        data: {
          email: inviteData,
          id_access_group: parseInt(selectedAccesGroup),
        },
        json: true,
      });
      handleClose();
      setInviteData('');
      setSelectedAccessGroup('');
      setLoadingData(false);
      toast.success('Convite enviado para o e-mail com sucesso!', {
        position: toast.POSITION.TOP_RIGHT,
        theme: 'colored',
      });
    } catch (e) {
      setLoading(false);
      toast.error(e?.response?.data?.error, {
        position: toast.POSITION.TOP_RIGHT,
        theme: 'colored',
      });
    }
  };

  const loadData = async (searchData) => {
    setLoading(true);
    const resp = await api({
      method: 'GET',
      url: `/splitrisk-users`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: Cookies.get('splitrisk-authtoken'),
      },
      params: {
        search: searchData,
        page: currentPage,
        take: 30,
      },
      json: true,
    });

    setUserList(resp?.data?.users);
    setTotalCount(resp?.data?.totalCount);
    setHasNextPage(resp?.data?.hasNextPage);
    setLoading(false);
  };

  const feature = async () => {
    setLoading(true);
    const resp = await api({
      method: 'GET',
      url: `/access-groups`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: Cookies.get('splitrisk-authtoken'),
      },
      json: true,
    });

    setFeatureAcess(resp.data.response);
    setLoading(false);
  };

  const handleLoadMore = async () => {
    const page = currentPage + 1;

    if (hasNextPage && !loadingMore) {
      setLoadingMore(true);

      const resp = await api({
        method: 'GET',
        url: `/splitrisk-users`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: Cookies.get('splitrisk-authtoken'),
        },
        params: {
          search,
          page,
          take: 10,
        },
        json: true,
      });

      const data = userList;
      const ndata = data.concat(resp?.data?.users);

      setCurrentPage(page);
      setUserList(ndata);
      setHasNextPage(resp?.data?.hasNextPage);
      setLoadingMore(false);
    }
  };

  const handleOpenModal = () => setOpen(true);

  const handleClose = () => setOpen(false);

  useEffect(() => {
    loadData(search);
    feature();
  }, []);

  return (
    <>
      <Header />
      <Container>
        <SideMenu />

        <ContentArea>
          <Div>
            <Title>USUÁRIOS</Title>

            <div className="containerTitle">
              <Button height="30px" onClick={handleOpenModal}>
                Convidar
              </Button>

              <Dialog open={open} onClose={handleClose} title="Convidar usuário">
                <Subtitle id="modal-description">Insira abaixo somente o e-mail do usuário que deseja convidar.</Subtitle>
                <SelectLine>
                  <Select
                    label="Escolha o grupo de acesso"
                    height="35px"
                    value={selectedAccesGroup}
                    onChange={(e) => setSelectedAccessGroup(e.target.value)}
                  >
                    <option value="">Selecione</option>
                    {featureAcess?.map((role) => (
                      <option value={role.id}>{role.name}</option>
                    ))}
                  </Select>
                </SelectLine>
                <Input
                  label="E-mail do usuário"
                  placeholder="E-mail"
                  height="35px"
                  width="95%"
                  value={inviteData}
                  onChange={(e) => setInviteData(e.target.value)}
                />

                <ModalButton>
                  <Button
                    onClick={inviteUser}
                    height="30px"
                    disabled={loading || !inviteData || !selectedAccesGroup || selectedAccesGroup === ''}
                  >
                    {loadingData ? <ReactLoading color="#ffff" height={20} width={20} type="spin" /> : 'Convidar'}
                  </Button>
                </ModalButton>
              </Dialog>

              <Search
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                onClear={() => {
                  setSearch('');
                  loadData('');
                }}
                onConfirm={() => loadData(search)}
              />
            </div>
          </Div>

          <DataArea ref={scrollParent}>
            <InfiniteScroll
              loadMore={handleLoadMore}
              hasMore={hasNextPage}
              useWindow={false}
              getScrollParent={() => scrollParent?.current}
              initialLoad={false}
              style={{ width: '100%', display: 'flex' }}
              threshold={10}
            >
              <DataTable
                onRowClicked={(row) => history.push(`/backoffice/detalhes-do-usuario/${row?.id}`)}
                persistTableHead
                responsive
                columns={dataColumns}
                data={userList}
                highlightOnHover
                pointerOnHover
                fixedHeader
                fixedHeaderScrollHeight="100%"
                progressPending={loading}
                progressComponent={
                  <LoadingArea>
                    <ReactLoading color={loadingColor} height={40} width={40} type="spin" />
                  </LoadingArea>
                }
                noDataComponent={<small style={{ marginTop: 20 }}>Nenhum usuário encontrado</small>}
              />
            </InfiniteScroll>
          </DataArea>
          <CountArea>
            {loadingMore && <ReactLoading color={loadingColor} height={20} width={20} type="spin" />}

            {!loadingMore && !loading && (
              <p style={{ color: primary }}>
                Mostrando {userList?.length} de {totalCount}
              </p>
            )}
          </CountArea>
        </ContentArea>
      </Container>
    </>
  );
}

export default User;
